// Utility to convert IATA codes to city names and coordinates
// This provides a mapping for common IATA codes to their city information

import { getCityCoordinates as getDynamicCoordinates } from './geocodingService';

const IATA_TO_CITY = {
  // Major US Cities
  'LAX': { name: 'Los Angeles', country: 'United States', coordinates: { lat: 34.0522, lng: -118.2437 } },
  'NYC': { name: 'New York City', country: 'United States', coordinates: { lat: 40.7128, lng: -74.0060 } },
  'JFK': { name: 'New York City', country: 'United States', coordinates: { lat: 40.6413, lng: -73.7781 } },
  'LGA': { name: 'New York City', country: 'United States', coordinates: { lat: 40.7769, lng: -73.8740 } },
  'SFO': { name: 'San Francisco', country: 'United States', coordinates: { lat: 37.7749, lng: -122.4194 } },
  'LAS': { name: 'Las Vegas', country: 'United States', coordinates: { lat: 36.1699, lng: -115.1398 } },
  'MIA': { name: 'Miami', country: 'United States', coordinates: { lat: 25.7617, lng: -80.1918 } },
  'CHI': { name: 'Chicago', country: 'United States', coordinates: { lat: 41.8781, lng: -87.6298 } },
  'ORD': { name: 'Chicago', country: 'United States', coordinates: { lat: 41.9786, lng: -87.9048 } },
  'BOS': { name: 'Boston', country: 'United States', coordinates: { lat: 42.3601, lng: -71.0589 } },
  'SEA': { name: 'Seattle', country: 'United States', coordinates: { lat: 47.6062, lng: -122.3321 } },
  'DEN': { name: 'Denver', country: 'United States', coordinates: { lat: 39.7392, lng: -104.9903 } },
  'ATL': { name: 'Atlanta', country: 'United States', coordinates: { lat: 33.7490, lng: -84.3880 } },
  'DFW': { name: 'Dallas', country: 'United States', coordinates: { lat: 32.7767, lng: -96.7970 } },
  'PHX': { name: 'Phoenix', country: 'United States', coordinates: { lat: 33.4484, lng: -112.0740 } },
  'MCO': { name: 'Orlando', country: 'United States', coordinates: { lat: 28.5383, lng: -81.3792 } },

  // Major European Cities
  'LHR': { name: 'London', country: 'United Kingdom', coordinates: { lat: 51.5074, lng: -0.1278 } },
  'LGW': { name: 'London', country: 'United Kingdom', coordinates: { lat: 51.1481, lng: -0.1903 } },
  'CDG': { name: 'Paris', country: 'France', coordinates: { lat: 48.8566, lng: 2.3522 } },
  'ORY': { name: 'Paris', country: 'France', coordinates: { lat: 48.7233, lng: 2.3794 } },
  'FCO': { name: 'Rome', country: 'Italy', coordinates: { lat: 41.9028, lng: 12.4964 } },
  'MAD': { name: 'Madrid', country: 'Spain', coordinates: { lat: 40.4168, lng: -3.7038 } },
  'BCN': { name: 'Barcelona', country: 'Spain', coordinates: { lat: 41.3851, lng: 2.1734 } },
  'AMS': { name: 'Amsterdam', country: 'Netherlands', coordinates: { lat: 52.3676, lng: 4.9041 } },
  'FRA': { name: 'Frankfurt', country: 'Germany', coordinates: { lat: 50.1109, lng: 8.6821 } },
  'MUC': { name: 'Munich', country: 'Germany', coordinates: { lat: 48.1351, lng: 11.5820 } },
  'ZUR': { name: 'Zurich', country: 'Switzerland', coordinates: { lat: 47.3769, lng: 8.5417 } },
  'VIE': { name: 'Vienna', country: 'Austria', coordinates: { lat: 48.2082, lng: 16.3738 } },
  'CPH': { name: 'Copenhagen', country: 'Denmark', coordinates: { lat: 55.6761, lng: 12.5683 } },
  'ARN': { name: 'Stockholm', country: 'Sweden', coordinates: { lat: 59.3293, lng: 18.0686 } },
  'OSL': { name: 'Oslo', country: 'Norway', coordinates: { lat: 59.9139, lng: 10.7522 } },

  // Major Asian Cities
  'NRT': { name: 'Tokyo', country: 'Japan', coordinates: { lat: 35.6762, lng: 139.6503 } },
  'HND': { name: 'Tokyo', country: 'Japan', coordinates: { lat: 35.5494, lng: 139.7798 } },
  'ICN': { name: 'Seoul', country: 'South Korea', coordinates: { lat: 37.5665, lng: 126.9780 } },
  'HKG': { name: 'Hong Kong', country: 'Hong Kong', coordinates: { lat: 22.3193, lng: 114.1694 } },
  'SIN': { name: 'Singapore', country: 'Singapore', coordinates: { lat: 1.3521, lng: 103.8198 } },
  'BKK': { name: 'Bangkok', country: 'Thailand', coordinates: { lat: 13.7563, lng: 100.5018 } },
  'KUL': { name: 'Kuala Lumpur', country: 'Malaysia', coordinates: { lat: 3.1390, lng: 101.6869 } },
  'MNL': { name: 'Manila', country: 'Philippines', coordinates: { lat: 14.5995, lng: 120.9842 } },
  'DEL': { name: 'Delhi', country: 'India', coordinates: { lat: 28.6139, lng: 77.2090 } },
  'BOM': { name: 'Mumbai', country: 'India', coordinates: { lat: 19.0760, lng: 72.8777 } },
  'BLR': { name: 'Bangalore', country: 'India', coordinates: { lat: 12.9716, lng: 77.5946 } },
  'SHA': { name: 'Shanghai', country: 'China', coordinates: { lat: 31.2304, lng: 121.4737 } },
  'PEK': { name: 'Beijing', country: 'China', coordinates: { lat: 39.9042, lng: 116.4074 } },
  'CAN': { name: 'Guangzhou', country: 'China', coordinates: { lat: 23.1291, lng: 113.2644 } },

  // Middle East & Africa
  'DXB': { name: 'Dubai', country: 'United Arab Emirates', coordinates: { lat: 25.2048, lng: 55.2708 } },
  'AUH': { name: 'Abu Dhabi', country: 'United Arab Emirates', coordinates: { lat: 24.4539, lng: 54.3773 } },
  'DOH': { name: 'Doha', country: 'Qatar', coordinates: { lat: 25.2854, lng: 51.5310 } },
  'JED': { name: 'Jeddah', country: 'Saudi Arabia', coordinates: { lat: 21.4858, lng: 39.1925 } },
  'RUH': { name: 'Riyadh', country: 'Saudi Arabia', coordinates: { lat: 24.7136, lng: 46.6753 } },
  'CAI': { name: 'Cairo', country: 'Egypt', coordinates: { lat: 30.0444, lng: 31.2357 } },
  'JNB': { name: 'Johannesburg', country: 'South Africa', coordinates: { lat: -26.2041, lng: 28.0473 } },
  'CPT': { name: 'Cape Town', country: 'South Africa', coordinates: { lat: -33.9249, lng: 18.4241 } },
  'NBO': { name: 'Nairobi', country: 'Kenya', coordinates: { lat: -1.2921, lng: 36.8219 } },

  // Oceania
  'SYD': { name: 'Sydney', country: 'Australia', coordinates: { lat: -33.8688, lng: 151.2093 } },
  'MEL': { name: 'Melbourne', country: 'Australia', coordinates: { lat: -37.8136, lng: 144.9631 } },
  'BNE': { name: 'Brisbane', country: 'Australia', coordinates: { lat: -27.4698, lng: 153.0251 } },
  'AKL': { name: 'Auckland', country: 'New Zealand', coordinates: { lat: -36.8485, lng: 174.7633 } },

  // South America
  'GRU': { name: 'São Paulo', country: 'Brazil', coordinates: { lat: -23.5505, lng: -46.6333 } },
  'GIG': { name: 'Rio de Janeiro', country: 'Brazil', coordinates: { lat: -22.9068, lng: -43.1729 } },
  'EZE': { name: 'Buenos Aires', country: 'Argentina', coordinates: { lat: -34.6118, lng: -58.3960 } },
  'SCL': { name: 'Santiago', country: 'Chile', coordinates: { lat: -33.4489, lng: -70.6693 } },
  'LIM': { name: 'Lima', country: 'Peru', coordinates: { lat: -12.0464, lng: -77.0428 } },
  'BOG': { name: 'Bogotá', country: 'Colombia', coordinates: { lat: 4.7110, lng: -74.0721 } },

  // Canada
  'YYZ': { name: 'Toronto', country: 'Canada', coordinates: { lat: 43.6532, lng: -79.3832 } },
  'YVR': { name: 'Vancouver', country: 'Canada', coordinates: { lat: 49.2827, lng: -123.1207 } },
  'YUL': { name: 'Montreal', country: 'Canada', coordinates: { lat: 45.5017, lng: -73.5673 } }
};

export const getCityFromIATA = (iataCode) => {
  if (!iataCode || typeof iataCode !== 'string') {
    return null;
  }
  
  const code = iataCode.toUpperCase().trim();
  return IATA_TO_CITY[code] || null;
};

export const getCityName = (iataCode) => {
  const city = getCityFromIATA(iataCode);
  return city ? city.name : iataCode;
};

export const getCityCoordinates = (iataCode) => {
  const city = getCityFromIATA(iataCode);
  return city ? city.coordinates : null;
};

export const getCityCountry = (iataCode) => {
  const city = getCityFromIATA(iataCode);
  return city ? city.country : null;
};

// City name to coordinates mapping for common cities
const CITY_TO_COORDINATES = {
  'rome': { lat: 41.9028, lng: 12.4964 },
  'london': { lat: 51.5074, lng: -0.1278 },
  'paris': { lat: 48.8566, lng: 2.3522 },
  'new york': { lat: 40.7128, lng: -74.0060 },
  'new york city': { lat: 40.7128, lng: -74.0060 },
  'dallas': { lat: 32.7767, lng: -96.7970 },
  'houston': { lat: 29.7604, lng: -95.3698 },
  'austin': { lat: 30.2672, lng: -97.7431 },
  'miami': { lat: 25.7617, lng: -80.1918 },
  'los angeles': { lat: 34.0522, lng: -118.2437 },
  'san francisco': { lat: 37.7749, lng: -122.4194 },
  'chicago': { lat: 41.8781, lng: -87.6298 },
  'boston': { lat: 42.3601, lng: -71.0589 },
  'seattle': { lat: 47.6062, lng: -122.3321 },
  'tokyo': { lat: 35.6762, lng: 139.6503 },
  'sydney': { lat: -33.8688, lng: 151.2093 },
  'barcelona': { lat: 41.3851, lng: 2.1734 },
  'amsterdam': { lat: 52.3676, lng: 4.9041 },
  'berlin': { lat: 52.5200, lng: 13.4050 },
  'dubai': { lat: 25.2048, lng: 55.2708 },
  'singapore': { lat: 1.3521, lng: 103.8198 },
  'bangkok': { lat: 13.7563, lng: 100.5018 },
  'las vegas': { lat: 36.1699, lng: -115.1398 },
  'paris, france': { lat: 48.8566, lng: 2.3522 },
  'london, uk': { lat: 51.5074, lng: -0.1278 },
  'rome, italy': { lat: 41.9028, lng: 12.4964 },
  'madrid': { lat: 40.4168, lng: -3.7038 },
  'madrid, spain': { lat: 40.4168, lng: -3.7038 },
  'vienna': { lat: 48.2082, lng: 16.3738 },
  'vienna, austria': { lat: 48.2082, lng: 16.3738 },
  'prague': { lat: 50.0755, lng: 14.4378 },
  'prague, czech republic': { lat: 50.0755, lng: 14.4378 },
  'budapest': { lat: 47.4979, lng: 19.0402 },
  'budapest, hungary': { lat: 47.4979, lng: 19.0402 },
  'lisbon': { lat: 38.7223, lng: -9.1393 },
  'lisbon, portugal': { lat: 38.7223, lng: -9.1393 },
  'stockholm': { lat: 59.3293, lng: 18.0686 },
  'stockholm, sweden': { lat: 59.3293, lng: 18.0686 },
  'copenhagen': { lat: 55.6761, lng: 12.5683 },
  'copenhagen, denmark': { lat: 55.6761, lng: 12.5683 },
  'oslo': { lat: 59.9139, lng: 10.7522 },
  'oslo, norway': { lat: 59.9139, lng: 10.7522 },
  'helsinki': { lat: 60.1699, lng: 24.9384 },
  'helsinki, finland': { lat: 60.1699, lng: 24.9384 }
};

export const getCityCoordinatesFromName = async (cityName) => {
  const normalizedName = cityName.toLowerCase().trim();
  
  // First check our static mapping for common cities
  if (CITY_TO_COORDINATES[normalizedName]) {
    return CITY_TO_COORDINATES[normalizedName];
  }
  
  // If not found, try dynamic geocoding
  try {
    console.log(`🔍 Dynamic geocoding for: ${cityName}`);
    const coordinates = await getDynamicCoordinates(cityName);
    return coordinates;
  } catch (error) {
    console.warn(`⚠️ Dynamic geocoding failed for ${cityName}:`, error.message);
    return null;
  }
};
